import React from 'react'

import styled from 'styled-components'

import { Grid } from '@components/ui/Grid'
import { Typography } from '@components/ui/Typography'
import { Paper } from '@components/ui/Wrappers'

import { ContentWrapperDiv } from './styles'

const PanelPaper = styled(Paper)`
  margin-top: 15px;
  overflow: hidden;
`

const PanelHeaderGrid = styled(Grid)`
  background-color: ${({ theme }) => theme.colors.gray[102]};
  padding: 15px 15px 15px 30px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray[105]};
`

const PanelBodyGrid = styled(Grid)`
  padding: 35px 30px 45px;

  & h4 {
    margin-bottom: 20px;
  }
`

interface SettingsBlockProps {
  button?: React.ReactNode
  children: React.ReactNode
  className?: string
  heading: StringOrMessage
  id?: string
  withWrapper?: boolean
}

// TODO - reusable element for settings pages - later move to styled components and V2 design
export const SettingsBlock = React.forwardRef<HTMLDivElement, SettingsBlockProps>(
  ({ button, children, className, heading, id, withWrapper }, ref) => {
    const content = withWrapper ? (
      <Grid item xs={12}>
        <ContentWrapperDiv>{children}</ContentWrapperDiv>
      </Grid>
    ) : (
      children
    )

    return (
      <PanelPaper className={className} id={id} ref={ref}>
        <PanelHeaderGrid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography size="heading-5" tag="h3" color="gray-70">
              {heading}
            </Typography>
          </Grid>
          {button && <Grid item>{button}</Grid>}
        </PanelHeaderGrid>
        <PanelBodyGrid container>{content}</PanelBodyGrid>
      </PanelPaper>
    )
  }
)

SettingsBlock.displayName = 'SettingsBlock'
